import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';

import { isMarketUrl } from 'APP/Tasks/market/isMarketUrl';
import { SpaceRoutes } from 'APP/main/SpaceView/SpaceView.constants';
import { RouterLink } from 'APP/router/constants';
import { buildPath } from 'APP/router/helpers/buildPath';
import { Space } from 'STORE/Spaces/Space';

interface ISpacePanelPresenter {
  spaceRoute: string;
  marketsRoute: string;
  marketRoute: string;
  isShowMarketsRoute: boolean;
  isShowPrimaryMarketRoute: boolean;
}

export function useSpacePanelPresenter(space: Space | null): ISpacePanelPresenter {
  const location = useLocation();
  const source = useAsObservableSource({ location, space });

  const presenter = useLocalStore<ISpacePanelPresenter>(() => ({
    get spaceRoute(): string {
      return RouterLink.Space.replace(':id', source.space?.id || '');
    },

    get marketRoute(): string {
      return buildPath([RouterLink.Space, SpaceRoutes.Market], { id: source.space?.id });
    },

    get marketsRoute(): string {
      return buildPath([RouterLink.Space, SpaceRoutes.Markets], { id: source.space?.id });
    },

    get isShowMarketsRoute(): boolean {
      return (
        (!!source.space?.isOwner ||
          !!source.space?.marketsCount ||
          source.location.pathname.includes(presenter.marketsRoute)) &&
        !presenter.isShowPrimaryMarketRoute
      );
    },

    get isShowPrimaryMarketRoute(): boolean {
      return (
        !source.space?.isOwner &&
        source.space?.marketsCount === 1 &&
        !!source.space?.primaryMarketUrl &&
        isMarketUrl(source.space?.primaryMarketUrl)
      );
    },
  }));

  return presenter;
}
